/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Wait for DOM to render



$(document).ready(function(){
  
  //hide congratulations top bar
  $("#shopify-section-announcement-bar").hide();
  $("#shopify-section-header").css("top", "0 !important");
  var fsbInterval = setInterval(function(){
    if( $("#shopify-section-announcement-bar").text().length > 1 ){
        clearInterval(fsbInterval);
        if( $("#shopify-section-announcement-bar").text().indexOf("Congratulations") == -1 ){
          $("#shopify-section-announcement-bar").show();
          $("#shopify-section-header").addClass("slideBelow");
        }
    }
  }, 1000);

  //remove upload after atc
  $(document).on("product:added", function(){
    $(".upload-lift-container .filepond--file button").click();
  })
  
  //enforce MOQ
  if( window.location.href.indexOf("/cart") !== -1 )
    enforceMOQ();
  
  //enforce MOQ on qty change
  $(document).on("click keyup", ".quantity-selector__button, .quantity-selector__value", function(){
    var moqCheck = setInterval(function(){
      if( !$(".cart-msg ul li").length ) {
        enforceMOQ();
        hideUploadProp();
      }
    }, 1000)
  });
  
  //hide uploaded image link
  hideUploadProp();
  
})

function hideUploadProp(){
  $('.line-item__property').each(function(i, obj) {
    if( $(this).text().indexOf("upload_") == 0 )
        $(this).hide();
  });
}

function enforceMOQ(){
    var moqProds=[];
    $('tr.moq-product').each(function(i, obj) {
      var moq =  $(this).attr("data-moq"),
      handle =  $(this).attr("data-product-handle"),
      totalQty = qtyInCart(handle);
      
      if( $.inArray(handle, moqProds) == -1 && moq > totalQty ){
        var productTitle = $(this).find(".line-item__title h1").text()+" | "+$(this).find(".line-item__title h2").text();
        var msg  = "Minimum order quantity for"+ productTitle.replace(/\s+/g, " ") + "is "+moq+"";
        $(".cart-msg ul").append('<li>'+msg+'</li>');
        //$(".cart-warning").removeClass("hide");
        moqProds.push(handle);
        $('button[name="checkout"]').css({"pointer-events":"none", "background": "#d1d1d4"});
      }
    });
}

function qtyInCart(handle){
    var totalQty = 0; 
    $('tr[data-product-handle="'+handle+'"]').each(function(i, obj) {
      totalQty += parseInt($(this).find(".quantity-selector__value").val());
    });
    return totalQty;
}

// Search Type Writer

// var words = [ "Pure Glass", "Bio Glass", "Original EZ Splitz", "Lock N Load 9mm Chillum" , "EZ Fire", "Lock N Load Stagati", "EZ Cap and Crusher"];

// const TypeWriter = {
//   speed:150,
//   selector:'',
//   wordsArr:[],
//   currWordPos:1,
//   timer:false,

//   start:function(selector,wordsArr,speed=150){
//     this.speed = speed;
//     this.selector = selector;
//     this.wordsArr = wordsArr;

//     this.type(words[this.currWordPos],this.nextWord)
//   },

//   nextWord:function(){
//     TypeWriter.currWordPos++;
//     if(TypeWriter.currWordPos == TypeWriter.wordsArr.length) TypeWriter.currWordPos=0;
//     setTimeout(function(){
//       TypeWriter.type(TypeWriter.wordsArr[TypeWriter.currWordPos],TypeWriter.nextWord)
//     },1)
//   },
  
//   type: function(text, callback) {
//     let size = 1;
//     let inc = true;
//     let wait = 16;

//     TypeWriter.timer = setInterval(function () {
//       let placeholder = text.substring(0,size);
//       $(TypeWriter.selector).attr("placeholder",placeholder);
  
//       if(inc){
//         size++;
//         if(size == text.split('').length)
//           inc = false;
//       }
//       else{
//         if(wait>0){
//           wait--;
//           return;
//         }
//         size--;
//         if(size < 0){
//           clearInterval(TypeWriter.timer)
//           callback();
//         }
//       }
  
//     },TypeWriter.speed)
//   }
// }
// TypeWriter.start('.header .search-bar__input',words);
/*setTimeout(function(){
  console.log( $("#snize-mobile-search-input").attr("id") );
 TypeWriter.start('#snize-mobile-search-input',words); 
}, 10000);*/



// GA prd add to cart event
// window.dataLayer = window.dataLayer || [];
// $(document).on("product:added", function(e){
//   console.log('product:added');
//   window.dataLayer.push({
//     "event" : "prd_add_to_cart"
//   });
// })

// GA checkout init event
// $(`form[action="/cart"]`).submit(function(e){
//   if($(this).find('button[name="checkout"]').length){
//     console.log('checkout_init');
//     window.dataLayer.push({
//       "event" : "checkout_init"
//     });
//   }
// });

// GA quick view event
// window.dataLayer = window.dataLayer || [];
// $(document).on("click", 'button[data-secondary-action="open-quick-view"]', function(e){
//   console.log('quick_view');
//   window.dataLayer.push({
//     "event" : "prd_quick_view"
//   });
// })


